// import { useEffect } from "react";
import CopyrightText from "./copyright-text";
import buyGoodsLogo from "../../assets/img/buygoods.png";
import buyGoodsWebLogo from "../../assets/img/buygoods.webp";


const BuyGoodsDisclaimer = () => {

    // option 2 for bg discalimer
    // useEffect(() => {
    //     const script = document.createElement("script");
    //     script.src = "https://display.buygoods.com/v1/disclaimer?id=disclaimer&account_id=ggid";
    //     script.async = true;
    //     document.body.appendChild(script);

    //     return () => {
    //         document.body.removeChild(script); // Clean up on unmount
    //     };
    // }, []);

    return (
        <section id="bg-disclaimer">
            {/* <span id="disclaimer"></span> option2 for disclaimer*/}
            <div className="container-fluid gg-bg-solid-blue text-white">
                <div className="row text-center">
                    <div className="col-md-6 col-lg-4 mx-auto">
                        <picture>
                            <source srcSet={buyGoodsWebLogo} type="image/webp" />
                            <img src={buyGoodsLogo} alt="Buygoods Logo" className="img-fluid w-50 pb-3" loading="lazy"/>
                        </picture>
                    </div>
                </div>
                <div className="row text-center">
                    <div className="col-md-8 mx-auto">
                        <p className="fw-light gg-very-small-text">✱ These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure or prevent any disease. The information provided is not intended to be, nor is, medical advice or a substitute for medical advice. If you have or suspect you have, a specific medical condition or disease, please consult your healthcare provider.</p>
                        <p className="fw-light gg-very-small-text">BuyGoods is the retailer of this product. BuyGoods is a registered trademark of BuyGoods, a Delaware corporation located at 1201 N Orange Street Suite #7223, Wilmington, DE, 19801, USA and used by permission. BuyGoods role as retailer does not constitute an endorsement, approval or review of this product or any claim, statement or opinion used in promotion of this product.BuyGoods role as retailer does not constitute an endorsement, approval or review of this product or any claim, statement or opinion used in promotion of this product. Statements on this website have not been evaluated by the Food and Drug Administration. Products are not intended to diagnose, treat, cure or prevent any disease.</p>
                        <p className="small"><CopyrightText /></p>
                    </div>
                </div>
            </div>
        </section>
    )
};

export default BuyGoodsDisclaimer;